require('./nerudaUserAccountsView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
const PropTypes = require('prop-types');

// @ actions
const landingActions = require('actions/landings');
const { getChildList } = require('actions/openYoungDashboard');
const hiringProductBannersActions = require('actions/hiringProductBanners');

// @ core
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const AccountsProductBanners = require('components/accounts/accountsProductBanners/accountsProductBanners');
const AccountsProductCMSBanners = require('components/accounts/accountsProductCMSBanners/accountsProductCMSBanners');
const AccountsProductDropdown = require('components/accounts/accountsProductBanners/accountsProductDropdown');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const AccountBlockedErrorModal = require('components/accounts/accountBlockedErrorModal/accountBlockedErrorModal');

// @ helpers
const { conditionalClassName, contactCenterClassName } = require('utilities/conditionals/conditionalClassname');

// @ constants
const { GC, DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT } = require('constants/flagBasedFeatures');

class NerudaUserAccountsView extends React.PureComponent {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const { immFeatureToggling, validateBlockedAccount } = this.props;
        immFeatureToggling.get(DENIAL_ACCOUNT_HIRING_BLOCKED_ACCOUNT) &&
        validateBlockedAccount();
    }
    closeModal() {
        this.props.showAccountBlockedErrorModal(false);
    }

    render() {
        const {
            immAccounts,
            immFeatureToggling,
            immProfile,
            isAresUser,
            immHiringProductBanners,
            showAccountBlockedErrorModal
        } = this.props;
        const title = formatText('landingHeader-accounts');

        let accountsProductBanners;
        if(__CONTACT_CENTER__){
            accountsProductBanners = null;
        }
        else if (immFeatureToggling.get('web-gc-enabled') && immFeatureToggling.get(GC)) {
            accountsProductBanners = <AccountsProductCMSBanners limit={10}/>;
        } else {
            accountsProductBanners = <AccountsProductBanners immAccounts={immAccounts} amount={10} />;
        }

        const containerClassName = contactCenterClassName('grid-view neruda-user-accounts-view');
        const gridViewBodyClassName = contactCenterClassName('neruda-user-accounts-view__body', 'grid-view__body');
        const accountsViewLeftColumnClassName = conditionalClassName('col-xs-12 col-md-8 col-lg-8', 'neruda-user-accounts-view__left-column col-xs-6');
        const accountsViewRightColumnClassName = conditionalClassName('col-xs-12 col-md-4 col-lg-4', 'neruda-user-accounts-view__right-column col-xs-6');

        const OKHeaderView = (
            <OKCover size="small" section="accounts" customClass="col-xs-12">
                <OKHeaderLanding
                    inputClassName="ok-header-landing--accounts"
                    title={title}
                >
                    {!isAresUser && <ContactCenterRender>
                        <AccountsProductDropdown
                            amount={10}
                            immAccounts={immAccounts}
                            immFeatureToggling={immFeatureToggling}
                            immProfile={immProfile}
                            isNerudaUser
                            immHiringProductBanners={immHiringProductBanners}
                            showAccountBlockedErrorModal={showAccountBlockedErrorModal}
                        />
                    </ContactCenterRender>}
                </OKHeaderLanding>
            </OKCover>
        );

        const bodyClassNames = classNames('container-fluid', 'grid-view--content-position-positive');

        let accountBlockedErrorModal;
        if(__CONTACT_CENTER__) {
            const showErrorModal = immHiringProductBanners.get("showErrorModal");
            accountBlockedErrorModal = (
                <AccountBlockedErrorModal
                    description={<FormattedText value="accountBlockedErrorModal-errorDescriptionCC" />}
                    handleSubmit={this.closeModal}
                    showModal={showErrorModal}
                    title={formatText('accountBlockedErrorModal-errorTitleCC')}
                />
            )
        }

        return (
            <div className={containerClassName}>
                <div className="container-fluid">
                    <div className="row">
                        {OKHeaderView}
                    </div>
                </div>
                <div className={gridViewBodyClassName}>
                    <div className={bodyClassNames}>
                    <ContactCenterRender>
                        <div className="row">
                            {accountBlockedErrorModal}
                        </div>
                    </ContactCenterRender>
                        <div className="row">
                            <div className={accountsViewLeftColumnClassName}>
                                <div className="row">
                                    <div className="col-md-12">
                                        {accountsProductBanners}
                                    </div>
                                </div>
                            </div>
                            <div className={accountsViewRightColumnClassName}>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack isSmall={true} pageTitle={formatText('landingHeader-accounts')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NerudaUserAccountsView.propTypes = {
    boxToggle: PropTypes.func,
    children: PropTypes.any,
    getChildList: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFeatureToggling: PropTypes.shape({}).isRequired,
    immProfile: PropTypes.object,
    match: PropTypes.object.isRequired,
    isAresUser: PropTypes.bool.isRequired,
    validateBlockedAccount: PropTypes.func,
    immHiringProductBanners: PropTypes.object,
    showAccountBlockedErrorModal: PropTypes.func,
};

module.exports.constructor = NerudaUserAccountsView;
module.exports.NerudaUserAccountsView = connect(
    state => ({
        immAccounts: state.accounts,
        immFeatureToggling: state.flagBasedFeatures,
        immProfile: state.profile,
        immHiringProductBanners: state.hiringProductBanners,
    }),{
        boxToggle: landingActions.boxToggle,
        getChildList,
        validateBlockedAccount: hiringProductBannersActions.validateBlockedAccount,
        showAccountBlockedErrorModal: hiringProductBannersActions.showAccountBlockedErrorModal,
    }
)(NerudaUserAccountsView);
